<template>
    <div id="release-of-information">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="kingsGreen" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <release-of-information-toolbar></release-of-information-toolbar>
        <v-container class="fill-height justify-center" fluid>
            <release-of-information-form @setLoader="setLoader" @setNotification="setNotification">
            </release-of-information-form>
        </v-container>
    </div>
</template>

<script>
import ReleaseOfInformationForm from '../../components/Student/ReleaseOfInformation/Form';
import ReleaseOfInformationToolbar from '../../components/Student/ReleaseOfInformation/Toolbar';

export default {
    name: 'release-of-information',
    components: {
        ReleaseOfInformationForm,
        ReleaseOfInformationToolbar
    },
    data() {
        return {
            loader: true,
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        }
    }
}
</script>